import React from 'react';

import cs from 'classnames';

import type {ListResponseType} from 'sweet-types';

interface Props {
  currentPage: number;
  className?: string;
  onPageChange: (page: number) => unknown;
  response?: null | ListResponseType<unknown>;
}

export function ButtonPagination({
  currentPage,
  className,
  onPageChange,
  response,
}: Props): JSX.Element | null {
  if (!response || response.num_pages < 2) {
    return null;
  }

  const {num_pages, next, previous} = response;

  const buttons = Array(num_pages)
    .fill(null)
    .map((_, index) => ({
      active: index + 1 === currentPage,
      page: index + 1,
    }));

  return (
    <div className={cs('d-flex justify-content-center', className)}>
      <ul className="pagination mx-auto flex-wrap justify-content-center">
        {previous != null ? (
          <li key={'previous'} className="page-item">
            <button
              className="page-link"
              onClick={() => onPageChange(currentPage - 1)}
            >
              <i className="fa fa-arrow-left" />
            </button>
          </li>
        ) : null}
        {buttons.map(({page, active}) => (
          <li key={page} className={cs('page-item', {active})}>
            <button className="page-link" onClick={() => onPageChange(page)}>
              {page}
            </button>
          </li>
        ))}
        {next != null ? (
          <li key={'next'} className="page-item">
            <button
              className="page-link"
              onClick={() => onPageChange(currentPage + 1)}
            >
              <i className="fa fa-arrow-right" />
            </button>
          </li>
        ) : null}
      </ul>
    </div>
  );
}
